<template>
  <v-main>
    <BlockUI v-if="isLoading" :message="loadingMessage">
      <i class="fa fa-spinner fa-spin fa-2x fa-fw"></i>
    </BlockUI>
    <v-container>
      <div class="table-container">
        <table>
          <thead>
            <tr>
              <th style="visibility: hidden;"></th>
              <th>Total</th>
              <th>Planned</th>
              <th>Unplanned</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>Deck</td>
              <td>{{ getDischargeLoadSequencingVoyageContainersDetail.deck.total }}</td>
              <td>{{ getDischargeLoadSequencingVoyageContainersDetail.deck.planned }}</td>
              <td>{{ getDischargeLoadSequencingVoyageContainersDetail.deck.unplanned }}</td>
            </tr>
            <tr>
              <td>Hold</td>
              <td>{{ getDischargeLoadSequencingVoyageContainersDetail.hold.total }}</td>
              <td>{{ getDischargeLoadSequencingVoyageContainersDetail.hold.planned }}</td>
              <td>{{ getDischargeLoadSequencingVoyageContainersDetail.hold.unplanned }}</td>
            </tr>
          </tbody>
        </table>
      </div>
      <v-row>
          <single-bay-view :vesselHatch="getDischargeLoadSequencingVoyageContainersData.vesselHatches" style="margin-top: 100px;"></single-bay-view>
      </v-row>
    </v-container>
  </v-main>
</template>


<script ts>
import { mapGetters, mapActions, Store } from "vuex"
import ApiService from "@/core/services/api.service"
import SingleBayView from "@/view/pages/dischargeloadsequencing/components/SingleBayView/SingleBayView.vue"

export default {
  components: {
    SingleBayView
  },
  data() {
    return {     
    };
  },
methods: {
  ...mapActions(["fetchdischargeloadsequencingvoyagecontainerslist"]),

},
  created() {
    
  },
  computed: {
    ...mapGetters(['getIsDischargeLoadSequencingLoading','getDischargeLoadSequencingErrors','getDischargeLoadSequencingVoyageContainersDetail','getDischargeLoadSequencingVoyageContainersData']),
    isLoading: {
      get() {
        return this.getIsDischargeLoadSequencingLoading.length > 0 ? true : false
      },
      set(value) {
        this.setIsStowagInstructionLoading(value)
      }
    },
  },
  beforeCreate() {
    // Get the ID from the route
    const voyageId = this.$route.params.id

    const GroupFilter = {
      voyageId: parseInt(voyageId),
      Bay: parseInt(this.$route.query.Bay),
      ShowThroughContainers: this.$route.query.ShowThroughContainers == "True" ? true : false,
      VoyageOperationType: parseInt(this.$route.query.VoyageOperationType),
      QCContainerWorkType: parseInt(this.$route.query.QCContainerWorkType),
      SpreaderType: parseInt(this.$route.query.SpreaderType),
      SequencingDirection: parseInt(this.$route.query.SequencingDirection),
      BayOnDeck: this.$route.query.BayOnDeck == "True" ? true : false,
    }
    // page api request
    ApiService.setHeader();
    this.$store.dispatch("fetchdischargeloadsequencingvoyagecontainerslist", GroupFilter).then(() => {
      //this.loading = false;
      const errors = this.getDischargeLoadSequencingErrors;
      this.showErrors(errors);

    });
  },
}
</script>

<style scoped>.table-container {
  display: flex;
  justify-content: center;
  margin-top: 20px;
}

table {
  border-collapse: separate; /* Allows spacing between cells */
  border-spacing: 4px; /* Defines the margin between cells */
  width: 50%;
}

th, td {
  border: 1px solid black;
  padding: 12px 16px;
  text-align: center;
  font-weight: bold;
  font-size: 14px;
  width: 100px; /* Fixed width for all cells */
  height: 50px; /* Fixed height for all cells */
}

thead th {
  background-color: #f0f0f0;
}

tbody td {
  background-color: #fff;
}
</style>
